import {
  Box,
  Flex,
  type FlexProps,
  Link as ChakraLink,
} from '@chakra-ui/react';
import { Overline } from '@time-line/components/common';
import { TimelineLogo } from '@time-line/components/icons';
import { HOME } from 'lib/constants/routes';
import NextLink from 'next/link';

export function Header(props: FlexProps) {
  return (
    <Flex
      as="header"
      align="center"
      justify={{ base: 'space-between', lg: 'flex-start' }}
      gap="sm"
      py={{ base: 'sm', lg: 'lg' }}
      {...props}
    >
      <ChakraLink
        as={NextLink}
        href={HOME}
        title="Home"
        display="flex"
        alignItems="center"
        justifyContent={{ base: 'space-between', lg: 'flex-start' }}
        gap="sm"
        w="100%"
        color="inherit"
        _hover={{ textDecoration: 'none' }}
      >
        <TimelineLogo width={{ base: '114px', lg: '144px' }} height="auto" />
        <Box
          display={{ base: 'none', lg: 'block' }}
          h="20px"
          borderLeft="1px solid"
          borderColor="blackAlpha.250"
        />
        <Overline type="poweredBy" />
      </ChakraLink>
    </Flex>
  );
}
